import { PropTypes } from 'react'
import IconSVG from 'svg-inline-react'
import classnames from 'classnames'

function Icon(props) {
  const { className, style, src, size, width, height, color, ...restProps } = props

  let iconStyle = {}
  if (width && height) {
    iconStyle = { width, height }
  } else if (size) {
    iconStyle = {
      width: size,
      height: size
    }
  } else {
    throw Error("Either size or width and height must be given as props to Icon")
  }

  const srcFinal = src.replace(/fill="#[A-Z0-9]+"/i, `fill="${color}"`)
  return (
    <IconSVG src={srcFinal}
      raw
      style={{ ...style, ...iconStyle}}
      className={className}
      {...restProps} />
  )
}
Icon.propTypes = {
  /** icon source URI. Will use svg-loader to fetch contents */
  src: PropTypes.string.isRequired,
  /** Hex string for color */
  color: PropTypes.string,
  /** Width and Height of the icon */
  size: PropTypes.number,
  /** Width of the icon (when not square) */
  width: PropTypes.number,
  /** Height of the icon (when not square) */
  height: PropTypes.number
}
Icon.defaultProps = {
  color: 'white'
}

export default Icon



// WEBPACK FOOTER //
// ./node_modules/shared-web/src/components/Icon/index.js